// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1MutationReturn,
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  AccountToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {
  GraphQlDocument,
  GraphQlFragmentUnion,
  HookVariables,
} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  V1ContextInput,
  OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionConfirmInput,
} from '@stripe-internal/data-v1/schema/types';
import {setupSessionFragment} from 'src/api/graphql/setupSessionFragment';

import type {
  SetupSessionFragmentData,
  SetupSessionFragmentToken,
} from 'src/api/graphql/setupSessionFragment';

const doc = gql`
  mutation ConfirmCryptoSetupMutation(
    $input: OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionConfirmInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalSetupSessionCryptoSetupSessionConfirm(
      input: $input
      v1Context: $v1Context
    ) {
      id
      ...SetupSessionFragment
    }
  }
  ${setupSessionFragment}
`;

export const confirmCryptoSetupMutation: ConfirmCryptoSetupMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const confirmCryptoSetupMutationOptions: V1MutationOptionsWithoutVariables<ConfirmCryptoSetupMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useConfirmCryptoSetupMutation<
  THookVariables extends HookVariables<ConfirmCryptoSetupMutationVariables> = {},
>(
  options: V1MutationOptions<
    ConfirmCryptoSetupMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<ConfirmCryptoSetupMutationDocument, THookVariables> {
  return useV1Mutation(confirmCryptoSetupMutation, {
    ...confirmCryptoSetupMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type ConfirmCryptoSetupMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionConfirmInput>;
  v1Context: V1ContextInput;
}>;

export type ConfirmCryptoSetupMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalSetupSessionCryptoSetupSessionConfirm: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoSetupSession';
      readonly id: string;
    },
    [SetupSessionFragmentData]
  > | null;
};

export type ConfirmCryptoSetupMutationToken = SetupSessionFragmentToken &
  AccountToken<{
    Mutation_v1CryptoInternalSetupSessionCryptoSetupSessionConfirm: true;
  }>;

export type ConfirmCryptoSetupMutationDocument = GraphQlDocument<
  ConfirmCryptoSetupMutationData,
  ConfirmCryptoSetupMutationVariables,
  ConfirmCryptoSetupMutationToken
>;
